import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.form-label {
  margin-bottom: 0.25rem;
  line-height: 1.5;
  font-weight: 400;
  font-style: normal;
  box-sizing: border-box;
  display: inline-block;
}
.form-label-optional {
  color: #687078;
}
.form-label atlas-icon-button {
  top: 2px;
}
.form-label[skeleton-loading] {
  min-width: 40%;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Forms */
/* Form Checkbox/Radio */
/* Form Helper Message */
/* Z-index mapping for the floating elements */
/* Shadows */
/* Elevations */
.form-control {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  appearance: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: text;
}
.form-control > .form-control-input {
  border: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  width: 100%;
  cursor: text;
}
.form-control > .form-control-input:focus, .form-control > .form-control-input:focus-visible {
  outline: none;
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control.form-control-multiple {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  overflow-y: auto;
  max-height: 200px;
  cursor: text;
}
.form-control.form-control-multiple > .form-control-input {
  flex-grow: 1;
  min-width: 100px;
  width: 1%;
}
.form-control.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.form-control.form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.form-control.form-control-sm.with-height {
  height: calc(1.8125rem + 2px);
}
.form-control.form-control-md {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
}
.form-control.form-control-md > .form-control-input {
  font-size: 1rem;
}
.form-control.form-control-md.with-height {
  height: calc(2.5rem + 2px);
}
.form-control.form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.form-control.form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.form-control.form-control-lg.with-height {
  height: calc(2.875rem + 2px);
}
.form-control:focus, .form-control:focus-within {
  border-color: var(--atlas-primary-300);
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-primary-300-rgb), 0.25);
  outline: 0;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder,
.form-control > .form-control-input::placeholder {
  color: #687078;
  opacity: 1;
}
.form-control.disabled, .form-control:disabled, .form-control:has(.form-control-input:disabled) {
  background-color: var(--atlas-secondary-300);
  border-color: var(--atlas-secondary-300);
  color: #687078;
  opacity: 1;
  cursor: not-allowed;
}
.form-control.disabled > .form-control-input, .form-control:disabled > .form-control-input, .form-control:has(.form-control-input:disabled) > .form-control-input {
  color: #687078;
  cursor: not-allowed;
}
.form-control.readonly, .form-control:has(.form-control-input.readonly) {
  background-color: var(--atlas-secondary-100);
  border-color: var(--atlas-secondary-300);
  opacity: 1;
}
.form-control.readonly:focus, .form-control.readonly:focus-within, .form-control:has(.form-control-input.readonly):focus, .form-control:has(.form-control-input.readonly):focus-within {
  border-color: var(--atlas-secondary-300);
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-secondary-500-rgb), 0.25);
}
.form-control.hide-placeholder::placeholder,
.form-control.hide-placeholder > .form-control-input::placeholder {
  color: transparent;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  /* stylelint-disable no-descending-specificity */
  /* stylelint-enable no-descending-specificity */
}
.input-group atlas-button {
  position: relative;
  z-index: 2;
}
.input-group atlas-button:focus {
  z-index: 5;
}
.input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group .input-group-text.input-group-prefix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .input-group-text.input-group-suffix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group .form-control {
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group .form-control.has-icon {
  padding-right: 1.75rem;
}
.input-group .form-control.has-right-element, .input-group .form-control.has-action-button {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.input-group .form-control.has-left-element {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.input-group .form-control .input-icon,
.input-group .form-control ~ .input-icon {
  position: absolute;
  right: 0.75rem;
  top: 0.815rem;
  z-index: 5;
  pointer-events: none;
}
.input-group .form-control .input-icon.has-click,
.input-group .form-control ~ .input-icon.has-click {
  cursor: pointer;
  pointer-events: all;
}
.input-group .form-control .side-image,
.input-group .form-control ~ .side-image {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  height: 1.75rem;
  z-index: 5;
  pointer-events: none;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 5;
}
.input-group .form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .form-control-sm.has-icon {
  padding-right: 1.5rem;
}
.input-group .form-control-sm > .form-control-input {
  font-size: 0.875rem;
}
.input-group .form-control-sm .input-icon,
.input-group .form-control-sm ~ .input-icon {
  right: 0.5rem;
  top: 0.5rem;
}
.input-group .form-control-sm .side-image,
.input-group .form-control-sm ~ .side-image {
  right: 0.5rem;
  top: 0.25rem;
  height: 1.5rem;
}
.input-group .form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group .form-control-lg > .form-control-input {
  font-size: 1.25rem;
}
.input-group .form-control-lg.has-icon {
  padding-right: 2rem;
}
.input-group .form-control-lg .input-icon,
.input-group .form-control-lg ~ .input-icon {
  right: 1rem;
  top: 1rem;
}
.input-group .form-control-lg .side-image,
.input-group .form-control-lg ~ .side-image {
  right: 1rem;
  top: 0.5rem;
  height: 2rem;
}
.input-group:has(.form-control-sm) .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group:has(.form-control-lg) .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
}
.input-group:has(atlas-button.action-button-position-left) .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group:has(atlas-button.action-button-position-right) .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group > :not(:first-child):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.skeleton * {
  visibility: hidden;
}
.input-group.skeleton + atlas-button {
  display: none;
}

.input-feedback-group {
  display: flex;
  flex-direction: column;
}
.input-feedback-group.has-chars-counter.is-skeleton-loading:not(.has-status-feedback) {
  margin-top: 0.25rem;
}
.input-feedback-group.has-default-chars-counter {
  display: grid;
  grid-template-columns: 1fr fit-content(100%);
  column-gap: 0.5rem;
}
.input-feedback-group.has-default-chars-counter atlas-character-counter {
  grid-row: 1;
  grid-column: 2;
}
.input-feedback-group.has-default-chars-counter.has-status-feedback .status-feedback {
  grid-row: 1;
  grid-column: 1;
}
.input-feedback-group.has-default-chars-counter.has-status-feedback.is-skeleton-loading atlas-character-counter {
  display: none !important;
}
.input-feedback-group.has-default-chars-counter.has-status-feedback.is-skeleton-loading .status-feedback {
  grid-column: 1/-1;
}
.input-feedback-group.has-default-chars-counter.has-helper-text atlas-helper-text,
.input-feedback-group.has-default-chars-counter.has-helper-text slot[name=helper-text]::slotted(atlas-helper-text) {
  grid-column: 1/-1;
}
.input-feedback-group.has-default-chars-counter.has-helper-text:not(.has-status-feedback):not(.is-skeleton-loading) atlas-helper-text:first-of-type {
  grid-row: 1;
  grid-column: 1 !important;
}
.input-feedback-group.has-default-chars-counter.has-helper-text:not(.has-status-feedback):not(.is-skeleton-loading) slot[name=helper-text]::slotted(atlas-helper-text:first-of-type) {
  grid-row: 1;
  grid-column: 1 !important;
}
.input-feedback-group .status-feedback {
  display: inline-block;
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Shadows */
/* Elevations */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
.status-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

.is-info ~ .status-feedback {
  display: block;
}

.status-info {
  color: var(--atlas-secondary);
}

.is-success {
  border-color: var(--atlas-success) !important;
}
.is-success:focus, .is-success:focus-visible, .is-success.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
  border-color: var(--atlas-success);
}
.is-success ~ .status-feedback {
  display: block;
}
.is-success ~ .form-check-label {
  color: var(--atlas-success);
}
.is-success .focus-mark {
  background: var(--atlas-success-300);
}
.is-success.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-success) !important;
  background-color: rgba(var(--atlas-success-rgb), 2%);
}
.is-success.rating-buttons-group .rating-button {
  border-color: var(--atlas-success) !important;
  color: var(--atlas-success) !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-success-400) !important;
  color: #ffffff !important;
}
.is-success.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-success-500-rgb), 0.25);
}
.is-success.rating-buttons-group .rating-button:active:not(:disabled), .is-success.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-success) !important;
  color: #ffffff !important;
}

.form-check:has(.is-success) .form-check-label {
  color: var(--atlas-success);
}
.form-check:has(.is-success) .form-check-input:checked {
  background-color: var(--atlas-success);
}

.status-success {
  color: var(--atlas-success);
}

.is-warning {
  border-color: var(--atlas-warning) !important;
}
.is-warning:focus, .is-warning:focus-visible, .is-warning.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
  border-color: var(--atlas-warning);
}
.is-warning ~ .status-feedback {
  display: block;
}
.is-warning ~ .form-check-label {
  color: var(--atlas-warning);
}
.is-warning .focus-mark {
  background: var(--atlas-warning-300);
}
.is-warning.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-warning) !important;
  background-color: rgba(var(--atlas-warning-rgb), 2%);
}
.is-warning.rating-buttons-group .rating-button {
  border-color: var(--atlas-warning) !important;
  color: var(--atlas-warning) !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-warning-400) !important;
  color: #ffffff !important;
}
.is-warning.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-warning-500-rgb), 0.25);
}
.is-warning.rating-buttons-group .rating-button:active:not(:disabled), .is-warning.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-warning) !important;
  color: #ffffff !important;
}

.form-check:has(.is-warning) .form-check-label {
  color: var(--atlas-warning);
}
.form-check:has(.is-warning) .form-check-input:checked {
  background-color: var(--atlas-warning);
}

.status-warning {
  color: var(--atlas-warning);
}

.is-error {
  border-color: var(--atlas-danger) !important;
}
.is-error:focus, .is-error:focus-visible, .is-error.form-control:focus-within {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
  border-color: var(--atlas-danger);
}
.is-error ~ .status-feedback {
  display: block;
}
.is-error ~ .form-check-label {
  color: var(--atlas-danger);
}
.is-error .focus-mark {
  background: var(--atlas-danger-300);
}
.is-error.uploader-wrapper .uploader {
  border: 1px dashed var(--atlas-danger) !important;
  background-color: rgba(var(--atlas-danger-rgb), 2%);
}
.is-error.rating-buttons-group .rating-button {
  border-color: var(--atlas-danger) !important;
  color: var(--atlas-danger) !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):hover {
  background: var(--atlas-danger-400) !important;
  color: #ffffff !important;
}
.is-error.rating-buttons-group .rating-button:not(:disabled):focus {
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(var(--atlas-danger-500-rgb), 0.25);
}
.is-error.rating-buttons-group .rating-button:active:not(:disabled), .is-error.rating-buttons-group .rating-button.is-selected {
  background: var(--atlas-danger) !important;
  color: #ffffff !important;
}

.form-check:has(.is-error) .form-check-label {
  color: var(--atlas-danger);
}
.form-check:has(.is-error) .form-check-input:checked {
  background-color: var(--atlas-danger);
}

.status-error {
  color: var(--atlas-danger);
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host([width=full]) {
  width: 100%;
}

:host([width=xs]) {
  width: 96px;
}

:host([width=sm]) {
  width: 152px;
}

:host([width=md]) {
  width: 264px;
}

:host([width=lg]) {
  width: 380px;
}

:host {
  outline: none;
  display: block;
}

:host([skeleton-loading]) {
  display: block;
}

:host(.one-time-code-input) input {
  text-align: center;
}
:host(.one-time-code-input) input:focus::placeholder {
  opacity: 0;
}

:host(.atlas-select-input[prevent-writing]) .form-control,
:host(.atlas-select-input[prevent-writing]) .form-control input,
:host(.atlas-multiselect-input[prevent-writing]) .form-control,
:host(.atlas-multiselect-input[prevent-writing]) .form-control input {
  cursor: pointer;
}

:host(.atlas-select-input[disabled]) .form-control,
:host(.atlas-select-input[disabled]) .form-control input,
:host(.atlas-multiselect-input[disabled]) .form-control,
:host(.atlas-multiselect-input[disabled]) .form-control input {
  cursor: default;
}

:host(.atlas-select-input) atlas-icon.input-icon,
:host(.atlas-multiselect-input) atlas-icon.input-icon {
  transition: transform 0.35s ease;
}

:host(.atlas-select-input:not(.collapsed)) atlas-icon[name=chevron-down],
:host(.atlas-multiselect-input:not(.collapsed)) atlas-icon[name=chevron-down] {
  transform: rotate(-180deg);
}

:host(.atlas-multiselect-input.has-tag) .form-control {
  padding-left: 200px;
}

:host([type=hidden]) {
  display: none !important;
}

.form-label.skeleton {
  height: 1.5rem;
  width: 50%;
}

.form-control.skeleton {
  width: 100%;
  min-height: calc(1.5em + 14px);
}

.helper-text.skeleton {
  height: 1.25rem;
  width: 100%;
  margin-top: 0.25rem;
}

.input-wrapper {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 992px) {
  :host(.atlas-multiselect-input.has-tag) .form-control {
    padding-left: 190px;
  }
}
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Transitions */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* stylelint-disable selector-class-pattern */
/*! name: vanilla-calendar-pro v2.9.10 | url: https://github.com/uvarov-frontend/vanilla-calendar-pro */
.vanilla-calendar {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 300px;
  min-width: 272px;
  max-width: 100%;
  flex-direction: column;
  border-radius: 0.75rem;
  padding: 1rem;
  opacity: 1;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
}

@supports ((width: -webkit-max-content) or (width: max-content)) and ((height: -webkit-max-content) or (height: max-content)) {
  .vanilla-calendar {
    height: -webkit-max-content;
    height: max-content;
    width: -webkit-max-content;
    width: max-content;
  }
}
.vanilla-calendar_multiple {
  width: 550px;
}

@supports (width: -webkit-fit-content) or (width: -moz-fit-content) or (width: fit-content) {
  .vanilla-calendar_multiple {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
}
.vanilla-calendar button:focus-visible {
  border-radius: 0.5rem;
  outline-style: solid;
  outline-width: 1px;
  outline-offset: -1px;
}

.vanilla-calendar.vanilla-calendar_multiple .vanilla-calendar-days {
  flex-grow: 0;
}

.vanilla-calendar_hidden {
  pointer-events: none;
  opacity: 0;
}

.vanilla-calendar_hidden * {
  pointer-events: none !important;
}

.vanilla-calendar_to-input {
  position: absolute;
}

.vanilla-calendar_to-input_bottom {
  margin-top: 0.25rem;
}

.vanilla-calendar_to-input_top {
  margin-top: -0.25rem;
}

.vanilla-calendar-controls {
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 20;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
}

.vanilla-calendar-arrow {
  pointer-events: auto;
  position: relative;
  display: block;
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  border-width: 0px;
  background-color: transparent;
}

.vanilla-calendar-arrow:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  --tw-content: "";
  content: var(--tw-content);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_prev:before {
  transform: rotate(90deg);
}

.vanilla-calendar-arrow.vanilla-calendar-arrow_next:before {
  transform: rotate(-90deg);
}

.vanilla-calendar-grid {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.75rem;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column {
  pointer-events: none;
  opacity: 0.3;
}

.vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_month, .vanilla-calendar-grid.vanilla-calendar-grid_disabled .vanilla-calendar-column.vanilla-calendar-column_year {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-column {
  display: flex;
  min-width: -webkit-min-content;
  min-width: min-content;
  flex-direction: column;
}

.vanilla-calendar-header {
  position: relative;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.vanilla-calendar-header__content {
  display: grid;
  flex-grow: 1;
  grid-auto-columns: -webkit-max-content;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
  padding-left: 1rem;
  padding-right: 1rem;
}

.vanilla-calendar-month, .vanilla-calendar-year {
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
}

.vanilla-calendar-month.vanilla-calendar-month_disabled, .vanilla-calendar-year.vanilla-calendar-year_disabled {
  pointer-events: none;
}

.vanilla-calendar-months {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-years {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  row-gap: 1rem;
  column-gap: 0.5rem;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month, .vanilla-calendar-years_selecting .vanilla-calendar-years__year {
  cursor: pointer;
}

.vanilla-calendar-months_selecting .vanilla-calendar-months__month .vanilla-calendar-months__month_disabled, .vanilla-calendar-years_selecting .vanilla-calendar-years__year .vanilla-calendar-years__year_disabled {
  cursor: default;
}

.vanilla-calendar-months__month, .vanilla-calendar-years__year {
  display: flex;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0.25rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled, .vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  pointer-events: none;
}

.vanilla-calendar-week-numbers {
  display: flex;
  flex-direction: column;
}

.vanilla-calendar-week-numbers__title {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-week-numbers__content {
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-week-number {
  margin: 0;
  display: flex;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-style: none;
  background-color: transparent;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
}

.vanilla-calendar-wrapper {
  display: flex;
  flex-grow: 1;
}

.vanilla-calendar-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.vanilla-calendar-week {
  margin-bottom: 0.5rem;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-items: center;
}

.vanilla-calendar-week__day {
  display: flex;
  width: 100%;
  min-width: 1.875rem;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
}

.vanilla-calendar-days {
  display: grid;
  flex-grow: 1;
  grid-template-columns: repeat(7, 1fr);
  align-items: center;
  justify-items: center;
  row-gap: 0.25rem;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn {
  cursor: pointer;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
}

.vanilla-calendar-days_selecting .vanilla-calendar-day__btn_disabled {
  cursor: default;
}

.vanilla-calendar-day {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.vanilla-calendar-day_hover-intermediate .vanilla-calendar-day__btn {
  border-radius: 0;
}

.vanilla-calendar-day_hover-first .vanilla-calendar-day__btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_hover-first.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-radius: 0.5rem;
}

.vanilla-calendar-day:focus-visible .vanilla-calendar-day__popup, .vanilla-calendar-day:hover .vanilla-calendar-day__popup {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day_selected-first .vanilla-calendar-day__btn_selected {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vanilla-calendar-day_selected-first.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn_selected {
  border-radius: 0.5rem;
}

.vanilla-calendar-day_selected-intermediate .vanilla-calendar-day__btn_selected {
  border-radius: 0;
}

.vanilla-calendar-day__btn {
  display: flex;
  height: 100%;
  min-height: 1.875rem;
  width: 100%;
  min-width: 1.875rem;
  cursor: default;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 0px;
  padding: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}

.vanilla-calendar-day__btn_today {
  font-weight: 700;
}

.vanilla-calendar-day__btn_disabled {
  pointer-events: none;
}

.vanilla-calendar-day__popup {
  transform: translate(-50%);
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 100%;
  z-index: 20;
  width: 8rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  opacity: 0;
}

.vanilla-calendar-day__popup:before {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:after {
  content: var(--tw-content);
  position: absolute;
}

.vanilla-calendar-day__popup:hover {
  pointer-events: auto;
  opacity: 1;
}

.vanilla-calendar-day__popup:before {
  content: "";
  left: 0;
  bottom: 0;
  z-index: -10;
  display: block;
  height: calc(100% - 4px);
  width: 100%;
  border-radius: 0.5rem;
}

.vanilla-calendar-time {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
  border-top-width: 1px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-style: solid;
  padding-top: 0.75rem;
}

.vanilla-calendar-time__content {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
}

.vanilla-calendar-time__hours {
  position: relative;
  margin-right: 0.35rem;
  width: 1.75rem;
}

.vanilla-calendar-time__hours:after {
  position: absolute;
  right: -5px;
  top: 50%;
  margin-top: calc(-50% + 1px);
  display: block;
  --tw-content: ":";
  content: var(--tw-content);
}

.vanilla-calendar-time__minutes {
  width: 1.75rem;
}

.vanilla-calendar-time__hours input, .vanilla-calendar-time__minutes input {
  position: relative;
  margin: 0;
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 0px;
  padding: 0.125rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.125rem;
}

.vanilla-calendar-time__hours input:focus-visible, .vanilla-calendar-time__minutes input:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__hours input:disabled, .vanilla-calendar-time__minutes input:disabled {
  cursor: default;
}

.vanilla-calendar-time__hours input:hover:disabled, .vanilla-calendar-time__minutes input:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__keeping {
  margin-left: 1px;
  margin-top: 0.25rem;
  width: 22px;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 0px;
  background-color: transparent;
  padding: 0;
  font-size: 0.69rem;
}

.vanilla-calendar-time__keeping:focus-visible {
  outline-style: solid;
  outline-width: 1px;
}

.vanilla-calendar-time__keeping:disabled {
  cursor: default;
}

.vanilla-calendar-time__keeping:hover:disabled {
  background-color: transparent;
}

.vanilla-calendar-time__ranges {
  display: grid;
  grid-auto-flow: row;
}

.vanilla-calendar-time__range {
  position: relative;
  z-index: 10;
  font-size: 0;
}

.vanilla-calendar-time__range:before {
  content: var(--tw-content);
  left: 0;
}

.vanilla-calendar-time__range:after {
  content: var(--tw-content);
  right: 0;
}

.vanilla-calendar-time__range:before, .vanilla-calendar-time__range:after {
  content: "";
  transform: translateY(-50%);
  pointer-events: none;
  position: absolute;
  top: 50%;
  z-index: 10;
  height: 0.5rem;
  width: 1px;
}

.vanilla-calendar-time__range input {
  position: relative;
  margin: 0;
  height: 1.25rem;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  outline-width: 0px;
}

.vanilla-calendar-time__range input::-webkit-slider-thumb {
  position: relative;
  z-index: 20;
  margin-top: -0.5rem;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-thumb {
  position: relative;
  z-index: 20;
  box-sizing: border-box;
  height: 1rem;
  width: 0.75rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-webkit-slider-runnable-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

.vanilla-calendar-time__range input::-moz-range-track {
  margin-top: 1px;
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  cursor: pointer;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}

@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?7686x6");
  src: url("fonts/Atlas-Icons.eot?7686x6#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?7686x6") format("truetype"), url("fonts/Atlas-Icons.woff?7686x6") format("woff"), url("fonts/Atlas-Icons.svg?7686x6#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e900";
}

.ati-alert:before {
  content: "\\e901";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e903";
}

.ati-align-justify:before {
  content: "\\e904";
}

.ati-apps:before {
  content: "\\e905";
}

.ati-arrow-down:before {
  content: "\\e906";
}

.ati-arrow-down-circle:before {
  content: "\\e907";
}

.ati-arrow-left:before {
  content: "\\e908";
}

.ati-arrow-right:before {
  content: "\\e909";
}

.ati-arrow-right-left:before {
  content: "\\e90a";
}

.ati-arrow-up:before {
  content: "\\e90b";
}

.ati-arrow-up-circle:before {
  content: "\\e90c";
}

.ati-arrow-up-right:before {
  content: "\\e90d";
}

.ati-asaas-logo:before {
  content: "\\e90e";
}

.ati-backspace:before {
  content: "\\e90f";
}

.ati-banco-abc-brasil:before {
  content: "\\e9ac";
}

.ati-banco-bmg:before {
  content: "\\e9ad";
}

.ati-banco-brb:before {
  content: "\\e9ae";
}

.ati-banco-da-amazonia:before {
  content: "\\e9af";
}

.ati-banco-do-brasil:before {
  content: "\\e910";
}

.ati-banco-industrial-do-brasil:before {
  content: "\\e9b0";
}

.ati-banco-original:before {
  content: "\\e9b1";
}

.ati-banese:before {
  content: "\\e9b2";
}

.ati-bank:before {
  content: "\\e911";
}

.ati-bank-of-america:before {
  content: "\\e9b3";
}

.ati-banpara:before {
  content: "\\e9b4";
}

.ati-bar-chart:before {
  content: "\\e912";
}

.ati-barcode:before {
  content: "\\e913";
}

.ati-bars:before {
  content: "\\e914";
}

.ati-base-logo:before {
  content: "\\e915";
}

.ati-bell:before {
  content: "\\e916";
}

.ati-bnb:before {
  content: "\\e9b5";
}

.ati-box:before {
  content: "\\e917";
}

.ati-bradesco:before {
  content: "\\e9b6";
}

.ati-briefcase:before {
  content: "\\e918";
}

.ati-btg-pactual:before {
  content: "\\e9b7";
}

.ati-c6-bank:before {
  content: "\\e9b8";
}

.ati-caixa:before {
  content: "\\e919";
}

.ati-calendar:before {
  content: "\\e91a";
}

.ati-calendar-check:before {
  content: "\\e952";
}

.ati-calendar-clock:before {
  content: "\\e9a9";
}

.ati-calendar-magnifier:before {
  content: "\\e9aa";
}

.ati-calendar-sync:before {
  content: "\\e91b";
}

.ati-camera:before {
  content: "\\e91c";
}

.ati-card:before {
  content: "\\e91d";
}

.ati-card-mastercard:before {
  content: "\\e91e";
}

.ati-celebrate:before {
  content: "\\e91f";
}

.ati-check:before {
  content: "\\e920";
}

.ati-check-circle:before {
  content: "\\e921";
}

.ati-check-filled:before {
  content: "\\e922";
}

.ati-chevron-down:before {
  content: "\\e923";
}

.ati-chevron-left:before {
  content: "\\e924";
}

.ati-chevron-right:before {
  content: "\\e925";
}

.ati-chevron-up:before {
  content: "\\e926";
}

.ati-circle:before {
  content: "\\e927";
}

.ati-citi-bank:before {
  content: "\\e9b9";
}

.ati-clock:before {
  content: "\\e928";
}

.ati-clock-filled:before {
  content: "\\e929";
}

.ati-cog:before {
  content: "\\e92a";
}

.ati-concentric-circles:before {
  content: "\\e92b";
}

.ati-contactless:before {
  content: "\\e92c";
}

.ati-copy:before {
  content: "\\e92d";
}

.ati-corner-up-right:before {
  content: "\\e92e";
}

.ati-credisis:before {
  content: "\\e92f";
}

.ati-dashboard:before {
  content: "\\e930";
}

.ati-daycoval:before {
  content: "\\e9ba";
}

.ati-deutsche-bank:before {
  content: "\\e9bb";
}

.ati-dollar-sign:before {
  content: "\\e931";
}

.ati-dollar-zap:before {
  content: "\\e932";
}

.ati-double-check:before {
  content: "\\e933";
}

.ati-download:before {
  content: "\\e934";
}

.ati-envelope:before {
  content: "\\e935";
}

.ati-eye:before {
  content: "\\e936";
}

.ati-eye-filled:before {
  content: "\\e937";
}

.ati-eye-off:before {
  content: "\\e938";
}

.ati-eye-off-filled:before {
  content: "\\e939";
}

.ati-facebook:before {
  content: "\\e93a";
}

.ati-file:before {
  content: "\\e93b";
}

.ati-file-check:before {
  content: "\\e93c";
}

.ati-file-dollar:before {
  content: "\\e93d";
}

.ati-file-invoice:before {
  content: "\\e9ab";
}

.ati-file-text:before {
  content: "\\e93e";
}

.ati-file-users:before {
  content: "\\e93f";
}

.ati-files:before {
  content: "\\e940";
}

.ati-filter:before {
  content: "\\e941";
}

.ati-flapp-store-logo:before {
  content: "\\e942";
}

.ati-flash:before {
  content: "\\e943";
}

.ati-gift:before {
  content: "\\e944";
}

.ati-github:before {
  content: "\\e945";
}

.ati-globe:before {
  content: "\\e946";
}

.ati-hammer:before {
  content: "\\e947";
}

.ati-hand-card:before {
  content: "\\e948";
}

.ati-hand-holding-money:before {
  content: "\\e949";
}

.ati-hand-shake:before {
  content: "\\e94a";
}

.ati-help-circle:before {
  content: "\\e94b";
}

.ati-hierarchy:before {
  content: "\\e94c";
}

.ati-home:before {
  content: "\\e94d";
}

.ati-id-card:before {
  content: "\\e94e";
}

.ati-info:before {
  content: "\\e94f";
}

.ati-instagram:before {
  content: "\\e950";
}

.ati-inter:before {
  content: "\\e951";
}

.ati-itau:before {
  content: "\\e953";
}

.ati-key:before {
  content: "\\e954";
}

.ati-keyboard:before {
  content: "\\e955";
}

.ati-link:before {
  content: "\\e956";
}

.ati-linkedin:before {
  content: "\\e957";
}

.ati-list:before {
  content: "\\e958";
}

.ati-loader:before {
  content: "\\e959";
}

.ati-lock:before {
  content: "\\e95a";
}

.ati-lock-filled:before {
  content: "\\e95b";
}

.ati-log-in:before {
  content: "\\e95c";
}

.ati-magnifier:before {
  content: "\\e95d";
}

.ati-mail-box:before {
  content: "\\e95e";
}

.ati-map-pin:before {
  content: "\\e95f";
}

.ati-market-pin:before {
  content: "\\e960";
}

.ati-maximize:before {
  content: "\\e961";
}

.ati-megaphone:before {
  content: "\\e962";
}

.ati-mercado-pago:before {
  content: "\\e9bc";
}

.ati-message-circle:before {
  content: "\\e963";
}

.ati-mic:before {
  content: "\\e964";
}

.ati-minus:before {
  content: "\\e965";
}

.ati-minus-circle:before {
  content: "\\e966";
}

.ati-money:before {
  content: "\\e967";
}

.ati-money-filled:before {
  content: "\\e968";
}

.ati-money-notes:before {
  content: "\\e969";
}

.ati-monitor:before {
  content: "\\e96a";
}

.ati-monitor-chart-up:before {
  content: "\\e96b";
}

.ati-moon:before {
  content: "\\e96c";
}

.ati-neon:before {
  content: "\\e9bd";
}

.ati-nubank:before {
  content: "\\e96d";
}

.ati-open-finance:before {
  content: "\\e96e";
}

.ati-pagbank:before {
  content: "\\e9be";
}

.ati-paperclip:before {
  content: "\\e96f";
}

.ati-pencil:before {
  content: "\\e970";
}

.ati-phone:before {
  content: "\\e971";
}

.ati-pic-pay:before {
  content: "\\e9bf";
}

.ati-pix:before {
  content: "\\e972";
}

.ati-pix-filled:before {
  content: "\\e9c5";
}

.ati-plus:before {
  content: "\\e973";
}

.ati-plus-circle:before {
  content: "\\e974";
}

.ati-power:before {
  content: "\\e975";
}

.ati-printer:before {
  content: "\\e976";
}

.ati-receipt:before {
  content: "\\e977";
}

.ati-refresh:before {
  content: "\\e978";
}

.ati-refresh-dollar:before {
  content: "\\e979";
}

.ati-repeat:before {
  content: "\\e97a";
}

.ati-rotate:before {
  content: "\\e97b";
}

.ati-rotate-dollar:before {
  content: "\\e97c";
}

.ati-safra:before {
  content: "\\e9c0";
}

.ati-santander:before {
  content: "\\e97d";
}

.ati-send:before {
  content: "\\e97e";
}

.ati-serasa:before {
  content: "\\e97f";
}

.ati-share:before {
  content: "\\e980";
}

.ati-shield:before {
  content: "\\e981";
}

.ati-shopping-bag:before {
  content: "\\e982";
}

.ati-shopping-cart-down:before {
  content: "\\e983";
}

.ati-shopping-cart-right:before {
  content: "\\e984";
}

.ati-sicoob:before {
  content: "\\e9c1";
}

.ati-sicredi:before {
  content: "\\e9c2";
}

.ati-slash:before {
  content: "\\e985";
}

.ati-sliders:before {
  content: "\\e986";
}

.ati-smartphone:before {
  content: "\\e987";
}

.ati-smartphone-contactless:before {
  content: "\\e988";
}

.ati-sort:before {
  content: "\\e989";
}

.ati-spanner:before {
  content: "\\e98a";
}

.ati-split-arrows:before {
  content: "\\e98b";
}

.ati-square:before {
  content: "\\e98c";
}

.ati-square-signs:before {
  content: "\\e98d";
}

.ati-star:before {
  content: "\\e98e";
}

.ati-star-filled:before {
  content: "\\e98f";
}

.ati-stone:before {
  content: "\\e9c3";
}

.ati-sun:before {
  content: "\\e990";
}

.ati-tag:before {
  content: "\\e991";
}

.ati-three-dots:before {
  content: "\\e992";
}

.ati-three-dots-horinzontal:before {
  content: "\\e993";
}

.ati-thumbs-down:before {
  content: "\\e994";
}

.ati-thumbs-up:before {
  content: "\\e995";
}

.ati-ticket:before {
  content: "\\e996";
}

.ati-trash:before {
  content: "\\e997";
}

.ati-truck:before {
  content: "\\e998";
}

.ati-unlink:before {
  content: "\\e999";
}

.ati-unlock:before {
  content: "\\e99a";
}

.ati-unlock-filled:before {
  content: "\\e99b";
}

.ati-upload:before {
  content: "\\e99c";
}

.ati-user:before {
  content: "\\e99d";
}

.ati-user-filled:before {
  content: "\\e99e";
}

.ati-user-plus:before {
  content: "\\e99f";
}

.ati-users:before {
  content: "\\e9a0";
}

.ati-video:before {
  content: "\\e9a1";
}

.ati-virtual-card:before {
  content: "\\e9a2";
}

.ati-wallet:before {
  content: "\\e9a3";
}

.ati-whatsapp:before {
  content: "\\e9a4";
}

.ati-x:before {
  content: "\\e9a5";
}

.ati-x-circle:before {
  content: "\\e9a8";
}

.ati-x-filled:before {
  content: "\\e9a6";
}

.ati-xp-investimentos:before {
  content: "\\e9c4";
}

.ati-youtube:before {
  content: "\\e9a7";
}

.calendar-backdrop {
  width: 100vw;
  height: 100vh;
  background: rgba(var(--atlas-dark-rgb), 40%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  visibility: hidden;
}
.calendar-backdrop.show {
  visibility: visible;
}

.vanilla-calendar {
  position: fixed;
  border-radius: 0.5rem;
  border: 1px solid #ced4da;
  padding: 1rem;
  width: 314px;
  z-index: 1000;
  background: #ffffff;
  inset: 0;
  margin: auto;
}
.vanilla-calendar:not(.show) {
  pointer-events: none;
}
.vanilla-calendar.vanilla-calendar_multiple {
  width: max-content;
  max-width: initial;
}

.vanilla-calendar-controls {
  padding: 1rem 1rem 0;
}

.vanilla-calendar-mobile-header {
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ced4da;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.vanilla-calendar-mobile-header .mobile-header-title {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #687078;
}
.vanilla-calendar-mobile-header .mobile-header-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.vanilla-calendar-mobile-header .mobile-header-controls .control-button {
  background: none;
  border: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
  color: #687078;
}
.vanilla-calendar-mobile-header .mobile-header-controls .control-button.active {
  color: #212529;
}

.vanilla-calendar-header {
  margin-bottom: 1rem;
  height: 24px;
}
.vanilla-calendar-header .vanilla-calendar-header__content {
  gap: 0.75rem;
  padding: 0;
}
.vanilla-calendar-header .vanilla-calendar-month,
.vanilla-calendar-header .vanilla-calendar-year {
  border: 0;
  padding: 0;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.15s ease;
}
.vanilla-calendar-header .vanilla-calendar-month:hover,
.vanilla-calendar-header .vanilla-calendar-year:hover {
  color: var(--atlas-primary);
}

.vanilla-calendar-arrow {
  width: 24px;
  height: 24px;
  font-size: 24px;
  padding: 0;
  line-height: normal;
  color: #687078;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-arrow:hover {
  background: var(--atlas-secondary-100);
}
.vanilla-calendar-arrow:active {
  background: var(--atlas-primary-100);
  color: var(--atlas-primary);
}

.vanilla-calendar-grid {
  gap: 0;
}
.vanilla-calendar-grid atlas-divider {
  margin-top: 40px;
}
.vanilla-calendar-grid atlas-divider:last-of-type {
  display: none;
}

.vanilla-calendar-content .vanilla-calendar-week {
  margin-bottom: 0.75rem;
}
.vanilla-calendar-content .vanilla-calendar-week .vanilla-calendar-week__day {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--atlas-primary);
  width: 40px;
  box-sizing: border-box;
  padding: 0 0.25rem;
}
.vanilla-calendar-content .vanilla-calendar-days {
  row-gap: 0;
  flex-grow: 0;
}

.vanilla-calendar-day {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  padding: 0.25rem;
  transition: background 0.15s ease;
}

.vanilla-calendar-day__btn,
.vanilla-calendar-months__month,
.vanilla-calendar-years__year {
  box-sizing: border-box;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background: #ffffff;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.vanilla-calendar-day__btn.vanilla-calendar-months__month, .vanilla-calendar-day__btn.vanilla-calendar-years__year,
.vanilla-calendar-months__month.vanilla-calendar-months__month,
.vanilla-calendar-months__month.vanilla-calendar-years__year,
.vanilla-calendar-years__year.vanilla-calendar-months__month,
.vanilla-calendar-years__year.vanilla-calendar-years__year {
  width: 54px;
  height: 54px;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_disabled, .vanilla-calendar-day__btn.vanilla-calendar-months__month_disabled, .vanilla-calendar-day__btn.vanilla-calendar-years__year_disabled,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-months__month.vanilla-calendar-months__month_disabled,
.vanilla-calendar-months__month.vanilla-calendar-years__year_disabled,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_disabled,
.vanilla-calendar-years__year.vanilla-calendar-months__month_disabled,
.vanilla-calendar-years__year.vanilla-calendar-years__year_disabled {
  opacity: 0.35;
}
.vanilla-calendar-day__btn:hover,
.vanilla-calendar-months__month:hover,
.vanilla-calendar-years__year:hover {
  background: var(--atlas-primary-100);
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_selected, .vanilla-calendar-day__btn.vanilla-calendar-months__month_selected, .vanilla-calendar-day__btn.vanilla-calendar-years__year_selected,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_selected,
.vanilla-calendar-months__month.vanilla-calendar-months__month_selected,
.vanilla-calendar-months__month.vanilla-calendar-years__year_selected,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_selected,
.vanilla-calendar-years__year.vanilla-calendar-months__month_selected,
.vanilla-calendar-years__year.vanilla-calendar-years__year_selected {
  background: var(--atlas-primary);
  color: #ffffff;
  font-weight: 700;
}
.vanilla-calendar-day__btn.vanilla-calendar-day__btn_today,
.vanilla-calendar-months__month.vanilla-calendar-day__btn_today,
.vanilla-calendar-years__year.vanilla-calendar-day__btn_today {
  border: 1px solid var(--atlas-primary);
}

.vanilla-calendar-day_selected-first,
.vanilla-calendar-day_hover-first {
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
}

.vanilla-calendar-day_selected-last,
.vanilla-calendar-day_hover-last {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}

.vanilla-calendar-day_selected-first:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_selected-last:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_selected-intermediate:has(.vanilla-calendar-day__btn),
.vanilla-calendar-day_hover-intermediate:has(.vanilla-calendar-day__btn) {
  background: var(--atlas-primary-100);
}

.vanilla-calendar-day_selected-first .vanilla-calendar-day__btn,
.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-first .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn,
.vanilla-calendar-day_hover-first.vanilla-calendar-day_hover-last .vanilla-calendar-day__btn {
  border-radius: 50%;
}

.vanilla-calendar-day_selected-first.vanilla-calendar-day_selected-last .vanilla-calendar-day__btn {
  border-radius: 50%;
}

.vanilla-calendar-day_hover-intermediate .vanilla-calendar-day__btn:not(.vanilla-calendar-day__btn_selected) {
  background: var(--atlas-primary-100);
  font-weight: 400;
  color: #212529;
  border-radius: 50%;
}

.vanilla-calendar-day_selected-intermediate {
  /* stylelint-disable-next-line */
}
.vanilla-calendar-day_selected-intermediate .vanilla-calendar-day__btn {
  background: var(--atlas-primary-100);
  font-weight: 400;
  color: #212529;
  border-radius: 50%;
}

.vanilla-calendar-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

@media screen and (min-width: 992px) {
  .vanilla-calendar {
    inset: unset;
    margin: unset;
  }
  .vanilla-calendar-mobile-header {
    display: none;
  }
  .vanilla-calendar-footer {
    display: none;
  }
}
/* stylelint-enable selector-class-pattern */
/* Transitions */
.fade {
  transition: opacity 0.25s ease;
}
.fade:not(.show) {
  opacity: 0;
}

.fade-and-scale {
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-and-scale.scale-vertically {
  transform: scale(1, 0.7);
}
.fade-and-scale.show {
  opacity: 1;
  transform: scale(1);
}

:host([data-popper-placement=top]),
:host([data-popper-placement=top]) .fade-and-scale,
div[data-popper-placement=top].fade-and-scale,
div[data-popper-placement=top] > .fade-and-scale,
.fade-and-scale.scale-top {
  transform-origin: center bottom;
}

:host([data-popper-placement=top-start]),
:host([data-popper-placement=top-start]) .fade-and-scale,
div[data-popper-placement=top-start].fade-and-scale,
div[data-popper-placement=top-start] > .fade-and-scale,
.fade-and-scale.scale-top-start {
  transform-origin: left bottom;
}

:host([data-popper-placement=top-end]),
:host([data-popper-placement=top-end]) .fade-and-scale,
div[data-popper-placement=top-end].fade-and-scale,
div[data-popper-placement=top-end] > .fade-and-scale,
.fade-and-scale.scale-top-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=bottom]),
:host([data-popper-placement=bottom]) .fade-and-scale,
div[data-popper-placement=bottom].fade-and-scale,
div[data-popper-placement=bottom] > .fade-and-scale,
.fade-and-scale.scale-bottom {
  transform-origin: center top;
}

:host([data-popper-placement=bottom-start]),
:host([data-popper-placement=bottom-start]) .fade-and-scale,
div[data-popper-placement=bottom-start].fade-and-scale,
div[data-popper-placement=bottom-start] > .fade-and-scale,
.fade-and-scale.scale-bottom-start {
  transform-origin: left top;
}

:host([data-popper-placement=bottom-end]),
:host([data-popper-placement=bottom-end]) .fade-and-scale,
div[data-popper-placement=bottom-end].fade-and-scale,
div[data-popper-placement=bottom-end] > .fade-and-scale,
.fade-and-scale.scale-bottom-end {
  transform-origin: right top;
}

:host([data-popper-placement=left]),
:host([data-popper-placement=left]) .fade-and-scale,
div[data-popper-placement=left].fade-and-scale,
div[data-popper-placement=left] > .fade-and-scale,
.fade-and-scale.scale-left {
  transform-origin: right center;
}

:host([data-popper-placement=left-start]),
:host([data-popper-placement=left-start]) .fade-and-scale,
div[data-popper-placement=left-start].fade-and-scale,
div[data-popper-placement=left-start] > .fade-and-scale,
.fade-and-scale.scale-left-start {
  transform-origin: right top;
}

:host([data-popper-placement=left-end]),
:host([data-popper-placement=left-end]) .fade-and-scale,
div[data-popper-placement=left-end].fade-and-scale,
div[data-popper-placement=left-end] > .fade-and-scale,
.fade-and-scale.scale-left-end {
  transform-origin: right bottom;
}

:host([data-popper-placement=right]),
:host([data-popper-placement=right]) .fade-and-scale,
div[data-popper-placement=right].fade-and-scale,
div[data-popper-placement=right] > .fade-and-scale,
.fade-and-scale.scale-right {
  transform-origin: left center;
}

:host([data-popper-placement=right-start]),
:host([data-popper-placement=right-start]) .fade-and-scale,
div[data-popper-placement=right-start].fade-and-scale,
div[data-popper-placement=right-start] > .fade-and-scale,
.fade-and-scale.scale-right-start {
  transform-origin: left top;
}

:host([data-popper-placement=right-end]),
:host([data-popper-placement=right-end]) .fade-and-scale,
div[data-popper-placement=right-end].fade-and-scale,
div[data-popper-placement=right-end] > .fade-and-scale,
.fade-and-scale.scale-right-end {
  transform-origin: left bottom;
}

:host {
  box-sizing: border-box;
  position: relative;
}

.form-control-range {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.form-control-range > .form-control-input {
  width: 85px;
}

.focus-mark {
  position: absolute;
  width: 85px;
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--atlas-primary-300);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
